var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlternanceYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.471,
    height: 29.7,
    viewBox: "0 0 25.471 29.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1076",
    "data-name": "Groupe 1076",
    transform: "translate(-741.328 -41.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10755",
    "data-name": "Trac\\xE9 10755",
    d: "M768.607,49.287c0-.018,0-.035,0-.052s0-.035,0-.053c0-.071-.007-.139-.008-.209,0-.088-.005-.175-.01-.262-.193-3.979-2.8-7.133-5.992-7.133s-5.8,3.154-5.992,7.133c-.005.087-.007.175-.01.262,0,.07-.008.138-.008.209,0,.018,0,.035,0,.053s0,.035,0,.052c0,.071.007.139.008.209,0,.088,0,.175.01.262.194,3.979,2.8,7.133,5.992,7.133s5.8-3.154,5.992-7.133c0-.087.008-.175.01-.262C768.6,49.426,768.607,49.357,768.607,49.287Z",
    transform: "translate(-8.534 0)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10756",
    "data-name": "Trac\\xE9 10756",
    d: "M759.412,76.526c-.3,15.214-10.4,15.214-10.7,0a.469.469,0,0,0-.661-.414c-4,1.8-6.726,5.339-6.726,9.414,0,6.722,25.471,6.722,25.471,0,0-4.075-2.723-7.615-6.726-9.414A.468.468,0,0,0,759.412,76.526Z",
    transform: "translate(0 -19.291)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10757",
    "data-name": "Trac\\xE9 10757",
    d: "M769.695,95.139l-1.107-9.177-1.06.513-1.06-.513L765.4,94.789A16.77,16.77,0,0,0,769.695,95.139Z",
    transform: "translate(-13.465 -24.822)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10758",
    "data-name": "Trac\\xE9 10758",
    d: "M768.435,83.715l1.093-.794a.59.59,0,0,0,.214-.659l-.417-1.285a.589.589,0,0,0-.56-.407h-1.351a.59.59,0,0,0-.561.407l-.417,1.285a.589.589,0,0,0,.214.659l1.093.794A.589.589,0,0,0,768.435,83.715Z",
    transform: "translate(-14.025 -21.807)",
    fill: "#ffc43e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternanceYellow);
export default __webpack_public_path__ + "static/media/alternance_yellow.bc03a6e13e9d5d69b058f3ba185c10d4.svg";
export { ForwardRef as ReactComponent };